import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auto-evaluacion',
  templateUrl: './auto-evaluacion.component.html',
  styleUrls: ['./auto-evaluacion.component.css']
})
export class AutoEvaluacionComponent implements OnInit {

  showDetalle:boolean;
  constructor() { }

  ngOnInit(): void {
    this.showDetalle=false;
  }
}